var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"gl-list-none gl-p-0"},_vm._l((_vm.events),function(event,index){return _c(_vm.eventComponent(event.action),{key:index,tag:"component",attrs:{"event":event}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }